/* v8 ignore start */
import { type PropsWithChildren } from 'react';

import useRoleProvider from './useRoleProvider';

const RoleProvider = ({ children }: PropsWithChildren<{}>) => {
  useRoleProvider();

  return <>{children}</>;
};

export default RoleProvider;
/* v8 ignore end */
